import { isNil } from 'lodash';
import i18n from '@/js/vue-i18n';

export const PRICE_TAGS_I18N_BASE = 'planning.promotionsMaintenance.offer.offerMechanic.priceTags';

export function usePriceTagText() {
    const tagText = (key, params = {}) =>
        i18n.global.t(`${PRICE_TAGS_I18N_BASE}.text.${key}`, params);

    const placeholderText = key => i18n.global.t(`${PRICE_TAGS_I18N_BASE}.placeholder.${key}`);

    const formatMoney = value => (isNil(value) || value === '' ? '–' : Number(value).toFixed(2));

    const formatPercent = value => (isNil(value) ? '–%' : `${value}%`);

    const ordinal = n => {
        const key = `${PRICE_TAGS_I18N_BASE}.text.ordinals.n${n}`;
        return i18n.translationExists(key) ? i18n.global.t(key) : tagText('ordinals.other', { n });
    };

    return { tagText, placeholderText, formatMoney, formatPercent, ordinal };
}

export default usePriceTagText;
